import type { BuilderPage } from '#types';

/**
 * The Builder page actually rendered. Under a split-url rewrite the address bar still shows the
 * requested URL, so anything that names the lander (Landing API lookup, lead pageurl, Everflow click)
 * reads the path from here instead of window.location.
 */

type ServedPage = {
	browserPathname: string;
	servedPath: string | null;
};

let servedPage: ServedPage | null = null;

type ServedPageData = Partial<Pick<BuilderPage, 'publishedUrl' | 'url'>>;

/**
 * The path getStaticProps selected the page by: publishedUrl in publish mode, Builder's url
 * otherwise. Null without page data (Builder preview).
 */
export function servedPathFromPageData(
	pageData: ServedPageData | undefined,
	publishMode: boolean,
): string | null {
	const path = publishMode ? pageData?.publishedUrl : pageData?.url;
	return path ?? null;
}

export function setServedPage(servedPath: string | null): void {
	servedPage = { browserPathname: window.location.pathname, servedPath };
}

/** Null once the browser has left the page that reported it, e.g. after router.push to /thank-you. */
export function getServedPathname(): string | null {
	if (servedPage === null) return null;
	if (window.location.pathname !== servedPage.browserPathname) return null;
	return servedPage.servedPath;
}
